import {useEffect, useState} from 'react'

/**
 * Check if the current page is embedded — either rendered inside an iframe/webview
 * or opened with the `vioEmbedded=1` URL param.
 *
 * Returns `false` on the server and on the first client render to keep SSR/CSR
 * output in sync; the real value is set in `useEffect` after hydration.
 */
const useIsEmbedded = (): boolean => {
  const [isEmbedded, setIsEmbedded] = useState(false)

  useEffect(() => {
    let embedded = false
    try {
      // If cross-origin, the comparison is allowed, but accessing properties is not.
      embedded = window.self !== window.top
    } catch {
      // Accessing window.top can throw on some setups — if so, we are embedded.
      embedded = true
    }

    if (!embedded && window.location?.search) {
      embedded =
        new URLSearchParams(window.location.search).get('vioEmbedded') === '1'
    }

    setIsEmbedded(embedded)
  }, [])

  return isEmbedded
}

export {useIsEmbedded}
